<template>
  <div class="regulatory-contract">
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
      @changeMethod="changeMethod"
    >
    </SiruiSearch>
    <!--内容区域-->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="loading"
        :data="tableData"
        :paging="true"
        height="250"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        @chooseClick="chooseClick"
        @clickBillNo="clickBillNo"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column type="checkbox" width="50" fixed="left"></vxe-table-column>
        <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
          :visible="item.visible"
          :type="item.type"
          :width="item.width"
        >
          <template v-slot="{ row }">
            <template v-if="item.field === 'billNo'">
              <a @click="showStockDetail(row)" href="javascript:void(0)">{{ row[item.field] }}</a>
            </template>
            <template v-else-if="item.field === 'billStatus'">{{
              translateStatus(row.billStatus)
            }}</template>
            <template v-else>{{ row[item.field] }}</template>
          </template>
        </vxe-table-column>
      </sirui-table>
      <template v-if="isShowStockDetailTable">
        <StockDetailTable ref="stockDetailRef" :tableDataList="stockDetail"></StockDetailTable>
      </template>
    </div>
  </div>
</template>

<script>
  import tableMixins from '@/common/mixins/table.js';
  import {
    searchFormColumns,
    baseColumnListDefault,
    searchFormColumns1,
    baseColumnListDefault1,
  } from './index.js';
  import tableBtnMixin from './tableBtnMixin';
  import StockDetailTable from './components/stockDetailTable/index.vue';
  import superviseBillApi from '@/api/park/superviseBill';
  export default {
    name: 'supervisionBillStockInquiry',
    mixins: [tableMixins, tableBtnMixin],
    data() {
      return {
        tableData: [],
        multipleSelection: [], // 表格被选中的行数据
        checkRowKeys: [],
        menuButtonList: [], // 表格功能按钮
        query: {
          billNo: null,
          billStatus: null,
          storageCompanyName: null,
          storageName: null,
          contractNo: null,
          billCreateDate: null,
        },
        supervisionBillStatusList: [], // 监管单状态状态
        contractNatureList: [], // 合同性质
        parkCompanyList: [], // 园区公司
        columnList: [],
        loading: false,
        selectionList: [],
        stockDetail: [],
        isShowStockDetailTable: false,
        pageMode: 1, // 1-外部账号查询；0-库存查询
      };
    },
    computed: {
      //表单字段
      searchColumns() {
        if (window.location.hash == '#/park/superviseBill/stockInquiry') {
          return searchFormColumns(this);
        }
        return searchFormColumns1(this);
      },
    },
    mounted() {
      if (window.location.hash == '#/park/superviseBill/stockInquiry') {
        this.pageMode = 0;
      }
      this.supervisionBillStatusList = this.dictListMap.SuperviseBillStatusType;
      this.contractNatureList = this.dictListMap.SuperviseContractNature;
      this.getButtonList();
      this.getTableData();
      this.$refs.siruiTable.setPageTotal(100);
    },
    methods: {
      // 选中复选框
      handleSelectionChange(row) {
        this.selectionList = row;
        console.log(this.selectionList);
      },
      // 搜索
      searchBtnClick() {
        this.getTableData();
      },
      // 重置
      resetBtnClick() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getTableData();
      },
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
          this.getColumnInfo();
        });
      },
      //获取当前列
      getColumnInfo() {
        if (this.pageMode == 0) {
          this.columnList = baseColumnListDefault;
        } else {
          this.columnList = baseColumnListDefault1;
        }
      },
      clickBillNo() {},
      // 表单中事件
      changeMethod(row) {
        if (row.prop == 'storageCompanyName') {
          // this.query.storageCompanyName = row.val;
        } else if (row.prop == 'storageName') {
          this.query.storageName = row.val[0].storageName;
        }
      },
      // 修改每页条数
      handleSizeChange() {
        this.$refs.siruiTable.setPageNum(1);
        this.getTableData();
      },
      // 修改当前页
      handleCurrentChange() {
        this.getTableData();
      },
      // 得到表格数据
      async getTableData() {
        this.isLoading = true;
        const postData = {
          ...this.query,
          pageNum: this.$refs.siruiTable.page.pageNum,
          pageSize: this.$refs.siruiTable.page.pageSize,
        };
        if (window.location.hash == '#/park/superviseBill/stockInquiry') {
          const { data } = await this.$axios.post(superviseBillApi.STOCK_PAGE_LIST, postData);
          this.isLoading = false;
          if (data.code == 0) {
            this.$refs.siruiTable.setPageTotal(data.data.total);
            this.tableData = data.data.records;
          } else {
            this.$message.error('查询表格数据失败');
            this.tableData = [];
          }
        } else {
          const { data } = await this.$axios.post(superviseBillApi.OUT_STOCK_QUERY_PAGE, postData);
          this.isLoading = false;
          console.log(data);
          if (data.code == 0) {
            this.$refs.siruiTable.setPageTotal(data.data.total);
            this.tableData = data.data.records;
            console.log(this.tableData);
          } else {
            this.$message.error('查询表格数据失败');
            this.tableData = [];
          }
        }
      },
      // 单击监管单号
      async showStockDetail(row) {
        this.isShowStockDetailTable = true;
        console.log(row, '库存明细');
        const billNo = row.billNo;
        console.log(billNo, 'billNo');
        this.isLoading = true;
        if (this.pageMode == 0) {
          const { data } = await this.$axios.post(
            `${superviseBillApi.STOCK_DETAIL_BY_BILLNO}/${billNo}`
          );
          this.isLoading = false;
          console.log(data);
          if (data.code == 0) {
            this.stockDetail = data.data;
            console.log(this.stockDetail, 'stockDetail');
          } else {
            console.error('获取数据失败');
          }
        } else {
          const { data } = await this.$axios.post(
            `${superviseBillApi.OUT_STOCK_QUERY_DETAIL}/${billNo}`
          );
          this.isLoading = false;
          console.log(data);
          if (data.code == 0) {
            this.stockDetail = data.data;
            console.log(this.stockDetail, 'stockDetail');
          } else {
            console.error('获取数据失败');
          }
        }
      },
      // 翻译表格状态 billStatus
      translateStatus(status) {
        return this.supervisionBillStatusList.find((item) => item.value == parseInt(status))?.label;
      },
    },
    components: {
      StockDetailTable,
    },
  };
</script>

<style lang="scss" scoped>
  sirui-table {
    height: 20px;
  }
</style>
